<template>
	<div class="sidebar-dropdown" ref="sidebarDropdown">
		<div v-for="(entry, index) in data" :key="entry.key" class="row" >
			<div class="col-12">
				<erco-dropdown class="_input"
				                 :items="mapItems(entry.enum)"
				                 :currentItemIndex="getCurrentItemIndexFor(entry)"
				                 @change="handleSelect(index, $event)">
				</erco-dropdown>
			</div>
		</div>
	</div>
</template>

<script>
	import ErcoDropdown from '@/components/molecules/ErcoDropdown';


	export default {
		name: 'ErcoSidebarDropdownMolecule',

		props: {
			data: {
				type: Array,
				default: () => [],
			},
		},

		methods: {
			handleSelect(index, newValue) {
				const key = this.data[index].key;

				const newSidebarContext = Object.assign({}, this.$store.state.sidebar.context);
				newSidebarContext.value[key] = newValue.currentValue;

				this.$store.dispatch('updateSidebar', { context: newSidebarContext });
			},
			mapItems(items) {
				return items.map(item => ({
					text: item.label,
					value: item.value,
				}));
			},
			getCurrentItemIndexFor(entry) {
				return entry.enum.reduce((fIdx, item, idx) =>
					(item.value.toString().trim() === entry.value.toString().trim() ? idx : fIdx), 0);
			},
		},

		components: {
			ErcoDropdown,
		},
	};
</script>

<style lang="scss">

	.sidebar-dropdown {
		padding: 0.5rem;
		padding-top: 1.5rem;

		.dropdown-menu {
			max-height: 50vh;
			overflow: auto;
		}
	}

</style>



// WEBPACK FOOTER //
// Dropdown.vue?14e75236